export const verifyWorklistName = (value) => {
  switch (value) {
    case "NOTIFICACAO_M1":
      return "Aprovisionamento de facilidades concluída"

    case "NOTIFICACAO_M2":
      return "Ativação lógica concluída"

    case "NOTIFICACAO_M3":
      return "Instalado / Desinstalado fisicamente"

    case "NOTIFICACAO_M4":
      return "Inventário de Rede/IP atualizados e ordem concluída no workflow."

    case "BLOQUEADO":
      return "Notificação de bloqueio concluído"

    case "DESBLOQUEADO":
      return "Notificação de desbloqueio concluído"

    case "INCIDENTE_TRATATIVA_INICIADA":
      return "Notificação de Tratativa iniciada."

    case "INCIDENTE_TRATATIVA_IMPROCEDENTE":
      return "Notificação de Tratativa finalizada como IMPROCEDENTE."

    case "INCIDENTE_TRATATIVA_REALIZADA":
      return "Notificação de Tratativa finalizada."

    case "INCIDENTE_NAO_ACEITO":
      return "Notificação de aceite de cliente finalizado com status ‘NÃO ACEITO’"

    case "INCIDENTE_ACEITO":
      return "Notificação de aceite de cliente finalizado com status ‘ACEITO’"

    case "VISITA_CONCLUIDA":
      return "Notificação de visita técnica finalizada."

    case "PORTABILIDADE_REVISADA":
      return "Notificação de portabilidade revisada"

    default:
      return value
  }
}



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/utils/verifyWorklistName.js